/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-09 21:45:41
 * @LastEditTime: 2022-05-26 13:50:33
 * @LastEditors: zhouxiaobo zhouxiaobo@yxj.org.cn
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

/* 写在前面
 * 用户信息相关的都是后端url上拼接，不需要再和App交互
 * 对于设置标题等等别的交互，用的都是4.2.0中的新的交互
 */

import Vue from 'vue'
import App from './App'
import router from './router'
import storage from 'storejs'
import storageByCode from "./utils/storageByCode";
import { createUuid, getUrlParam, getPs} from './../src/utils/common'
import store from './store'
import system from './utils/checkSystem.js'
import { Lazyload, Toast, InfiniteScroll, Picker } from 'mint-ui'
import {
  DropdownMenu,
  DropdownItem,
  Search,
  Cell,
  CellGroup,
  Button,
  Switch,
  Tab,
  Tabs,
  Swipe,
  SwipeItem,
  Sticky,
  ImagePreview,
  Overlay
} from 'vant'
import 'babel-polyfill'
import Es6Promise from 'es6-promise'
import { wxShareCinfig, wxShare } from './../src/utils/wxShare'
import {
  setShareInfo,
  setTitle,
  setNavTitleColor_old,
  setTitleColor_old,
  hideShareBtn
} from './../src/utils/JSbridge'
// import encode from "./server/api/encode";
import { versionDiff } from './utils/versionDiff'
import { checkSession } from './server/user/user'

// 神策埋点 start
import sa from 'sa-sdk-javascript'
import './utils/manulTrack' // 通过自定义指令实现给动态dom添加手动埋点监听的功能

import Vconsole from 'vconsole'
// if (process.env.EVN_CONFIG !== 'prod') new Vconsole()

// 引入图片懒加载
import VueLazyload from 'vue-lazyload'
console.log(process.env.EVN_CONFIG)

Vue.config.productionTip = false
Vue.use(Lazyload)
Vue.use(InfiniteScroll)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Search)
  .use(Cell)
  .use(CellGroup)
  .use(Button)
  .use(Switch)
  .use(Tab)
  .use(Tabs)
Vue.use(Swipe).use(SwipeItem)
Vue.use(Sticky)
Vue.use(Overlay)
Vue.use(ImagePreview)
Vue.use(VueLazyload, {
  preLoad: 1.3, // 预加载的宽高比
  error: 'https://studioyszimg.yxj.org.cn/1586314469505.png', // 图片加载失败时使用的图片源
  loading: 'https://studioyszimg.yxj.org.cn/1586314469505.png', // 图片加载的路径
  attempt: 1, // 尝试加载次数
  ListenEvents: ['scroll']
})

Vue.component(Picker.name, Picker)


// 兼容es6
require('es6-promise').polyfill()
Es6Promise.polyfill()
// 将地址栏获取到的placeSource字段复制到window对象上方便随时随地获取
window.$ps = getPs()
// 公共的弹窗样式
Vue.prototype.toast = function (msg, type) {
  if (type) {
    if (type === 'success') {
      window.toastName = Toast({
        message: msg,
        position: 'middle',
        className: 'toasts'
        // iconClass: 'icon iconfont icon-wancheng'
      })
      return window.toastName
    } else if (type === 'error') {
      window.toastName = Toast({
        message: msg,
        position: 'middle',
        className: 'toasts'
        // iconClass: 'icon iconfont icon-huabanfuben'
      })
      return window.toastName
    } else {
      window.toastName = Toast({
        message: msg,
        position: 'middle',
        className: 'toasts'
        // iconClass: 'icon iconfont icon-huabanfuben'
      })
      return window.toastName
    }
  } else {
    window.toastName = Toast({
      message: msg,
      position: 'middle',
      className: 'toasts'
      // iconClass: 'icon iconfont icon-huabanfuben'
    })
    return window.toastName
  }
}
let getEnvObj = process.env
window.appId = getEnvObj.appId
window.API_ROOT = getEnvObj.API_ROOT // 生产地址
window.saUrl = getEnvObj.saUrl
window.web_Url = document.location.protocol + getEnvObj.web_Url
window.wakeAppUrl = getEnvObj.wakeAppUrl // 跳转App链接
/** 神策初始化 */
sa.init({
  server_url: window.saUrl,
  //  http://47.100.226.93:8106/sa?project=production
  heatmap: {
    // 是否开启点击图，默认 default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭
    clickmap: 'default',
    // 是否开启触达注意力图，默认 default 表示开启，自动采集 $WebStay 事件，可以设置 'not_collect' 表示关闭
    scroll_notice_map: 'default'
  },
  is_track_single_page: true, // 开启单页面自动采集 $pageview 功能，SDK 会在 url 改变之后自动采集web页面浏览事件 $pageview
  app_js_bridge: true
})
/* console.log(sa.store.getDistinctId())
console.log(sa.store.getFirstId()) */

// 判断uuid缓存是否存在，不存在则重新生成
var getUuid = storageByCode('uuid')
if (!getUuid) {
  getUuid = createUuid()
  storageByCode('uuid', getUuid)
}
window.uuid = getUuid
/* eslint-disable no-new */
store.state.system = system()
store.state.isWeChat = /MicroMessenger/i.test(navigator.userAgent)

/** 获取页面url信息 */
let urlChannel = getUrlParam('placeSource') // 页面来源区分
if (urlChannel) {
  store.state.placeSource = urlChannel
} else {
  if (store.state.isWeChat) {
    // w
    store.state.placeSource = 8
  } else {
    store.state.placeSource = 0
  }
  // 默认微信好友分享
}

let urlFrom = getUrlParam('from') // 针对微信分享，区分朋友圈  和 好友
if (urlFrom && (urlFrom === 'singlemessage' || urlFrom === 'groupmessage')) {
  // 好友、群组
  store.state.placeSource = 8
} else if (urlFrom && urlFrom === 'timeline') {
  // 朋友圈
  store.state.placeSource = 9
}
let version = getUrlParam('version')
let notNeedLogin = getUrlParam('notNeedLogin')
let isApp = getUrlParam('isApp')
console.log(notNeedLogin, 'notNeedLogin')
if (version) store.state.user.version = version // 版本
if (notNeedLogin) store.state.notNeedLogin = Number(notNeedLogin) // 是否需要登陆
if (isApp) store.state.isApp = Number(isApp) // 是否app

sa.login(
  storageByCode('uid') && storageByCode('uid') != -1
    ? storageByCode('uid')
    : sa.store.getDistinctId()
)

router.afterEach((to, from) => {
  setInterceptBarEvent(true)
  window.scrollTo(0, 0)

  if (to.meta.titleBg) {
    setTitleColor_old(to.meta.titleBg)
    setTitleColor(to.meta.titleBg)
  }
  if (to.meta.titleColor) {
    setNavTitleColor_old(to.meta.titleColor)
    setNavTitleColor(to.meta.titleColor)
  }
  document.title = to.meta.title
  let setShareInfo = {
    title: '医学界医生站：医学工具',
    desc:
      '汇集医学公式、临床指南、用药百科等医生常用工具，是医生临床用药决策的好帮手！',
    link:
      window.web_Url +
      '/medicalTools/index.html?notNeedLogin=1&sourceLocation=0&placeSource=1#',
    imgUrl: 'https://studioyszimg.yxj.org.cn/1573787979737.png'
  }
  console.log(setShareInfo)
  wxShare(setShareInfo)
  setTitle(to.meta.title)
  setTitle_new(to.meta.title)
  if (to.meta.showRightBtn) {
    // 显示右上角的文案
    setBarRightVisibility(false)
    console.log('mmm')
    if (to.meta.rightBtnTxt == '收藏') {
      modifyRightButtonTitle('我的收藏', modifyRightButtonTitleBackFun)
      handleRightButtonClick_CB(modifyRightButtonTitleBackFun)
    }
  } else {
    // 不显示APP右上角的文案
    setBarRightVisibility(true)
  }

  sa.quick('autoTrackSinglePage', {
    $screen_name: to.meta.buriedTitle,
    v1_sourceLocation: Number(getUrlParam('sourceLocation')), //	站内游览来源	数值	0-金刚区
    v1_placeSource: Number(getUrlParam('placeSource')) //	渠道来源	数值	0-APP
  })
})
console.log(process.env, 'process.env')
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})
/* const shareConfig = {
  link: res.shareUrl,
  title: res.shareTitle,
  desc: res.shareBrief,
  imgUrl: res.shareImg
} */
if (!/MicroMessenger/i.test(navigator.userAgent)) {
  // 非微信  隐藏分享按钮
  console.log('非微信')
  hideShareBtn(true)
  // setBarRightVisibility(true)
  // setBarLeftVisibility(true)
} else {
  // 微信环境
  wxShareCinfig()
}

/** 右上角为 收藏的的回调 */
function modifyRightButtonTitleBackFun () {
  console.log('main函数设置的点击右上角回调')
  // let oldUrl = window.location.href
  // router.push({ path: '/collection' })

  checkSession()
    .then(res => {
      router.push({ path: '/collection' })
    })
    .catch(res => {
      if (res.code === 999) {
      } else {
        // this.toast(res.msg)
        Vue.prototype.toast(res.msg, 'error')
      }
    })
  // window.location.href = oldUrl.split('#')+'#/collection'
}



// WEBPACK FOOTER //
// ./src/main.js